<template>
  <div class="experts-page" :class="{ 'experts-page--en': !isAr }">
    <section class="experts">
      <b-container fluid>
        <b-row class="intro-section justify-content-around">
          <b-col
            xl="6"
            lg="12"
            md="12"
            class="experts-intro-col d-flex align-items-center"
          >
            <div class="text-section">
              <div>
                <h5 class="mb-3 experts-hero-kicker">{{ langDec.experts_page_hero_kicker }}</h5>
                <h1 class="mb-3 experts-hero-title"><b>{{ langDec.experts_page_hero_title }}</b></h1>
                <p class="experts-hero-lead">{{ langDec.experts_page_hero_lead }}</p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="whyUExpert">
      <b-container fluid>
        <b-row class="justify-content-around">
          <b-col
            xl="12"
            lg="12"
            md="12"
            class="whyUExpert-col d-flex align-items-center justify-content-center text-center"
          >
            <div class="text-section">
              <div>
                <h2 class="mb-4">{{ langDec.experts_page_why_title }}</h2>
                <p class="text-muted experts-why-lead">
                  {{ langDec.experts_page_why_lead }}
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="greyBox">
      <b-container fluid>
        <b-row class="justify-content-around">
          <b-col xl="12" lg="12" md="12" class="greyBox-col d-flex align-items-center justify-content-center">
            <div class="text-section">
              <div class="greyBox-inner">
                <b-row class="experts-cards-row">
                  <b-col xl="4" lg="4" md="12" sm="12" class="experts-card-col d-flex">
                    <div class="greenCol">
                      <img class="box-icon" src="../assets/images/clubIcon.png" alt="">
                      <div>
                        <h5><b>{{ langDec.experts_page_box_club_title }}</b></h5>
                        <div class="details">
                          {{ langDec.experts_page_box_club_text }}
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col xl="4" lg="4" md="12" sm="12" class="experts-card-col d-flex">
                    <div class="greenCol">
                      <img class="box-icon" src="../assets/images/privacyIcon.png" alt="">
                      <div>
                        <h5><b>{{ langDec.experts_page_box_privacy_title }}</b></h5>
                        <div class="details">
                          {{ langDec.experts_page_box_privacy_text }}
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col xl="4" lg="4" md="12" sm="12" class="experts-card-col d-flex">
                    <div class="greenCol">
                      <img class="box-icon" src="../assets/images/customerIcon.png" alt="">
                      <div>
                        <h5><b>{{ langDec.experts_page_box_support_title }}</b></h5>
                        <div class="details">
                          {{ langDec.experts_page_box_support_text }}
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section>
      <expert-carousel
        layout="grid"
        :page-size="12"
        :key="'experts-page-' + currentLang"
      />
    </section>

    <section class="subscribe">
      <div class="subscribe-inner col-md-12 py-5 my-5 text-center">
        <h2 class="experts-subscribe-heading px-3">{{ langDec.experts_page_subscribe_heading }}</h2>
        <div class="description">
          <p
            v-if="!googleplay && !applestore"
            class="experts-app-unavailable mt-3 px-3"
          >
            <b>{{ langDec.experts_page_app_unavailable }}</b>
          </p>
          <b-button
            v-if="!googleplay && !applestore"
            class="px-4 py-2 my-4"
            variant="primary"
            @click="goToRoute('contactus')"
          >
            {{ langDec.nav_contact }}
          </b-button>
        </div>
        <div v-if="googleplay || applestore" class="action-btns mt-4">
          <b-button
            v-if="applestore"
            class="experts-store-btn experts-store-btn--apple px-4 py-3 mx-3 my-3"
            @click="goTowebsite(applestore)"
          >
            <div
              class="store-badge-inner carousel-btn-in-div px-3"
              :class="{ 'store-badge-inner--en': !isAr }"
            >
              <div class="store-badge-inner__icon store-badge-inner__icon--apple">
                <img
                  class="store-badge-inner__apple-img"
                  src="../assets/images/Apple_logo_white.svg.png"
                  alt=""
                >
              </div>
              <div class="carousel-btn-in-div-text store-badge-inner__text experts-store-text">
                <span>{{ langDec.nav_available_on }}</span>
                <br>
                <span>App Store</span>
              </div>
            </div>
          </b-button>
          <b-button
            v-if="googleplay"
            class="experts-store-btn experts-store-btn--google px-4 py-3 mx-3 my-3"
            variant="primary"
            @click="goTowebsite(googleplay)"
          >
            <div
              class="store-badge-inner px-3"
              :class="{ 'store-badge-inner--en': !isAr }"
            >
              <div class="store-badge-inner__icon store-badge-inner__icon--google">
                <svg class="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                  <path fill="none" d="M0,0h40v40H0V0z" />
                  <g>
                    <path d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z" fill="#EA4335" />
                    <path d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z" fill="#FBBC04" />
                    <path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z" fill="#4285F4" />
                    <path d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z" fill="#34A853" />
                  </g>
                </svg>
              </div>
              <div class="carousel-btn-in-div-text store-badge-inner__text experts-store-text">
                <span>{{ langDec.nav_available_on }}</span>
                <br>
                <span>Google Play</span>
              </div>
            </div>
          </b-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ExpertCarousel from "../components/ExpertCarousel.vue";

export default {
  name: "Experts",
  components: {
    ExpertCarousel,
  },
  data() {
    return {
      googleplay: process.env.VUE_APP_GOOGLEPLAYLINK,
      applestore: process.env.VUE_APP_APPLESTORELINK,
    };
  },
  computed: {
    ...mapGetters(["getLangData", "getlang"]),
    langDec() {
      return this.getLangData || {};
    },
    currentLang() {
      return this.getlang || "ar";
    },
    isAr() {
      return this.currentLang === "ar";
    },
  },
  methods: {
    goTowebsite(link) {
      window.open(link, "_blank");
    },
    goToRoute(name) {
      this.$router.push({ name }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.experts-intro-col {
  margin-inline-start: auto;
}

.experts-page--en .experts-intro-col {
  margin-inline-start: 0;
  margin-inline-end: auto;
}

.experts .intro-section {
  background-image: url(../assets/images/expertsBG.png);
  background-size: cover;
  background-position: right center;
  width: auto;
  height: 450px !important;
  color: white;
}

.experts-page--en .experts .intro-section {
  background-position: left center;
}

.experts .text-section {
  align-items: center;
  margin-inline-end: 70px;
  display: flex;
}

.experts-hero-kicker,
.experts-hero-title,
.experts-hero-lead {
  text-align: start;
}

.experts .text-section .experts-hero-title {
  font-size: 40px !important;
  font-weight: bolder !important;
  color: white;
}

.experts .text-section .experts-hero-lead {
  font-size: 24px;
  margin-bottom: 0;
}

/* whyUExpert */
.whyUExpert {
  padding: 80px 20px;
}

.whyUExpert .text-section {
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 20px;
  width: 65%;
  max-width: 100%;
  text-align: center;
}

.experts-why-lead {
  text-align: start;
}

/* greyBox */
.greyBox {
  padding: 20px 40px;
}

.greyBox .text-section {
  border-radius: 10px;
  padding: 20px 30px;
  font-size: 20px;
  width: 100%;
}

.greyBox-inner {
  width: 100%;
}

/* كروت متساوية الارتفاع في الصف الواحد */
.experts-cards-row {
  align-items: stretch;
}

.experts-card-col {
  margin-bottom: 3rem;
}

@media (min-width: 992px) {
  .experts-card-col {
    margin-bottom: 0;
  }
}

.greyBox .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.greenCol {
  position: relative;
  border: 3px solid #5eb47c;
  padding: 50px 30px;
  min-height: 200px;
  flex: 1 1 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  text-align: start;
  box-sizing: border-box;
}

.box-icon {
  width: 70px;
  position: absolute;
  top: -40px;
  right: 50px;
}

.experts-page--en .box-icon {
  right: auto;
  left: 50px;
}

.details {
  font-size: 17px;
  text-align: start;
}

/* subscribe */
.subscribe {
  background-color: #f5f5f5;
}

.subscribe-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.experts-subscribe-heading {
  max-width: 44rem;
  margin-inline: auto;
}

.experts-app-unavailable {
  color: #c0392b;
}

.experts-store-btn {
  color: #fff !important;
}

.experts-store-btn--apple {
  background-color: #000 !important;
  border-color: #000 !important;
}

.experts-store-btn--google {
  border-color: #000 !important;
}

.experts-store-text {
  font-size: 14px;
}

.store-badge-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
  gap: 0.875rem;
}

.store-badge-inner--en {
  flex-direction: row-reverse;
}

.store-badge-inner__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.store-badge-inner__icon--apple {
  width: 35px;
  height: 35px;
  color: #fff;
}

.store-badge-inner__icon--google {
  width: 40px;
  height: 40px;
}

.store-badge-inner__apple-img {
  width: 35px;
  height: auto;
  margin-top: -3px;
  display: block;
}

.store-badge-inner__text {
  font-size: 14px;
  line-height: 1.25;
  text-align: start;
}

@media (max-width: 991.98px) {
  .greyBox {
    padding: 50px 30px;
  }

  .intro-section {
    height: 550px !important;
  }

  .experts .text-section .experts-hero-title {
    font-size: 30px !important;
    font-weight: bolder !important;
  }

  .greyBox .text-section {
    padding: 10px;
  }

  .whyUExpert .text-section {
    padding: 10px;
    width: 80%;
  }
}

@media (max-width: 767.98px) {
  .greyBox {
    padding: 40px 10px;
  }

  .whyUExpert .text-section {
    width: 95%;
  }

  .intro-section {
    height: 350px !important;
  }

  .experts .text-section {
    margin-inline-end: 30px;
  }
}
</style>
